// https://prototype.sqprod.co/#/docs/squareup.api.items.Fee.InclusionType
var InclusionType = /*#__PURE__*/function (InclusionType) {
  InclusionType["ADDITIVE"] = "ADDITIVE";
  InclusionType["INCLUSIVE"] = "INCLUSIVE";
  return InclusionType;
}(InclusionType || {});
export default InclusionType;